enum Theme {
    DARK = "lxs-theme-dark",
    LIGHT = "lxs-theme-light",
}

export { Theme };
